export { Typography } from './Typography';
export type {
  TypographyProps,
  TypographyElement,
  VariantShape,
} from './Typography';
export type {
  DisplaySize,
  BodySize,
  AnnotationSize,
  UtilitySize,
  TypographyVariant,
  TypographyWeight,
  ResponsiveSize,
} from './Typography';
